import * as React from 'react'
import classNames from 'classnames'
import { IToastAlert } from './interface'
import { toast, ToastId } from 'react-toastify'
import { useTranslation } from 'react-i18next'
import './ToastAlert.scss'
import 'react-toastify/dist/ReactToastify.min.css'

const ToastAlert = ({ autoClose, className, icon, text, title, type, useTKey }: IToastAlert): ToastId => {
  const TOAST_ALERT_ICON = {
    error: 'icon-warning-square',
    info: 'icon-info',
    success: 'icon-check-square'
  }

  const TOAST_ICON = type === 'custom' ? <img src={icon || ''} /> : <i className={TOAST_ALERT_ICON[type]} />

  const ToastComponent = () => {
    const { t } = useTranslation()

    return (
      <>
        <div className='Toast__crust'></div>
        <div className='Toast__middle'>
          {title ? <p className='Toast__title'>{useTKey ? t(title) : title}</p> : <></>}
          <p className='Toast__text'>
            <>
              <span className='Toast__text-icon'>{TOAST_ICON}</span>
              {useTKey ? t(text) : text}
            </>
          </p>
        </div>
      </>
    )
  }

  return toast(<ToastComponent />, {
    autoClose, // if undefined autoClose defaults to 5000 ms
    className: classNames(className, type, {
      'no-icon': type === 'custom' && !icon
    }),
    closeButton: <CloseButton />,
    position: 'top-center'
  })
}

const CloseButton = (): JSX.Element => <i className='Toastify__close-button icon-close' />

export default ToastAlert
